module.exports = __WEBPACK_EXTERNAL_MODULE_65__;


//////////////////
// WEBPACK FOOTER
// external "weaPortalPublic"
// module id = 65
// module chunks = 0